(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-feature', {
            parent: 'entity',
            url: '/application-feature',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeature.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature/application-features.html',
                    controller: 'ApplicationFeatureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeature');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-feature-detail', {
            parent: 'entity',
            url: '/application-feature/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.applicationFeature.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-feature/application-feature-detail.html',
                    controller: 'ApplicationFeatureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationFeature');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationFeature', function($stateParams, ApplicationFeature) {
                    return ApplicationFeature.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('application-feature.new', {
            parent: 'application-feature',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature/application-feature-dialog.html',
                    controller: 'ApplicationFeatureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-feature', null, { reload: true });
                }, function() {
                    $state.go('application-feature');
                });
            }]
        })
        .state('application-feature.edit', {
            parent: 'application-feature',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature/application-feature-dialog.html',
                    controller: 'ApplicationFeatureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationFeature', function(ApplicationFeature) {
                            return ApplicationFeature.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-feature.delete', {
            parent: 'application-feature',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-feature/application-feature-delete-dialog.html',
                    controller: 'ApplicationFeatureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationFeature', function(ApplicationFeature) {
                            return ApplicationFeature.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-feature', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
